// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"137":"8557847c","213":"f889aece","239":"7a2bc7ad","453":"3766840a","455":"ed8d34a1"}[chunkId] + ".chunk.js";
};